import { QueryClientProvider } from '@tanstack/react-query'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

import { AuthProvider } from './contexts/authContext'
import { queryClient } from './libs/reactQuery'
import store, { persistor } from './reducers'
import { router } from './Router'
import { getCurrentTerms } from './services/appServices'

export function App() {
  useEffect(() => {
    getCurrentTerms()
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={<>Loading...</>} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
            <Analytics />
            <SpeedInsights />
          </AuthProvider>
          <Toaster />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}
